<template>
  <div class="c-latest-insights">
    <sc-placeholder name="jss-latest-insight-item" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Latest-Insights',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-latest-insights {
  > div {
    @include desktop-up {
      display: flex;
      margin: 3rem 0 1rem 0;
      flex-wrap: wrap;
    }
  }

  &:deep() {
    .c-latest-insight {
      margin-bottom: 4rem;

      @include desktop-up {
        width: calc(100% / 2);
      }

      &.full {
        @include desktop-up {
          width: calc(100%);
        }
      }

      &__label {
        display: inline-block;
        @include font-styles('Arial', 1.4rem, 600, normal, 1.6rem, 0, $white);
        background-color: $dark-blue;
        margin-bottom: 1rem;
        padding: 0.6rem 1rem;
        text-transform: uppercase;
      }

      &__title {
        display: block;
        @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $dark-blue);
        margin-bottom: 0.5rem;

        @include desktop-up {
          font-size: 2rem;
          line-height: 2.6rem;
          padding-right: 3rem;
        }
      }

      &__description {
        @include font-styles('Arial', 1.6rem, 300, normal, 2rem, 0, $dark-blue);
        margin-top: 1rem;
        margin-bottom: 2rem;

        @include desktop-up {
          font-size: 2rem;
          line-height: 2.6rem;
          padding-right: 3rem;
        }
      }

      &__date {
        @include font-styles('Arial', 1.4rem, 300, normal, 2rem, 0, $dark-blue);
        margin-bottom: 2rem;
      }

      .c-cta--secondary {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
